"use client";

import React from "react";
import EditSection, {
  TextEditor,
  ListItemEditor,
} from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";

export default function HokProductsEdit({
  content,
  onContentChange,
}: SectionContentProps) {
  const handleChange = (updated: Record<string, any>) => {
    onContentChange?.(updated);
  };

  return (
    <EditSection
      content={content}
      onContentChange={handleChange}
      contentFields={
        <>
          {/* Section Header */}
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Section Header</h4>
            <TextEditor
              label="Subtitle"
              value={content.subtitle}
              onChange={(v) => handleChange({ ...content, subtitle: v })}
              placeholder="Latest Products"
            />
            <TextEditor
              label="Title"
              value={content.title}
              onChange={(v) => handleChange({ ...content, title: v })}
              placeholder="Newest Themes and Templates"
            />
            <TextEditor
              label="Description"
              value={content.description}
              onChange={(v) => handleChange({ ...content, description: v })}
              placeholder="Each week, our team curates..."
              multiline
            />
            <div className="flex items-center gap-2 py-1">
              <input
                type="checkbox"
                id="showCta"
                checked={content.showCta !== false}
                onChange={(e) => handleChange({ ...content, showCta: e.target.checked })}
                className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500 cursor-pointer"
              />
              <label htmlFor="showCta" className="text-xs font-medium text-gray-700 cursor-pointer">
                Show Call to Action Button
              </label>
            </div>
            {content.showCta !== false && (
              <>
                <TextEditor
                  label="CTA Text"
                  value={content.ctaText}
                  onChange={(v) => handleChange({ ...content, ctaText: v })}
                  placeholder="Explore All Items"
                />
                <TextEditor
                  label="CTA Link"
                  value={content.ctaUrl || ""}
                  onChange={(v) => handleChange({ ...content, ctaUrl: v })}
                  placeholder="/products or https://..."
                  multiline
                />
              </>
            )}
          </div>

          {/* Tabs */}
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Filter Tabs</h4>
            <ListItemEditor
              label="Tabs"
              items={content.tabs || [
                { label: "All Items", filter: "all" },
                { label: "Site Templates", filter: "site" },
                { label: "Mobile App UI", filter: "mobile" },
                { label: "Presentation Decks", filter: "present" },
                { label: "E-commerce Platforms", filter: "ecom" },
                { label: "Landing Pages", filter: "landing" },
                { label: "Dashboard Interfaces", filter: "dashboard" },
              ]}
              itemSchema={[
                { key: "label", label: "Label", type: "text" },
                { key: "filter", label: "Filter", type: "text" },
              ]}
              onChange={(items) => handleChange({ ...content, tabs: items })}
              addItemText="Add Tab"
            />
          </div>

          {/* Products */}
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Products</h4>
            <ListItemEditor
              label="Items"
              items={content.products || [
                { title: "Elevate your brand with elite meta ads experts", category: "SaaS", price: "$39", sales: "1200 Sales", rating: 5, ratingCount: "123", image: "/assets/img/product/product_2_1.png" },
                { title: "Boost your online presence with tailored marketing strategies", category: "E-commerce", price: "$49", sales: "1500 Sales", rating: 5, ratingCount: "123", image: "/assets/img/product/product_2_2.png" },
                { title: "Transform your business with expert guidance", category: "Consulting", price: "$59", sales: "800 Sales", rating: 5, ratingCount: "123", image: "/assets/img/product/product_2_3.png" },
                { title: "Learn new skills with interactive and engaging content", category: "Online Courses", price: "$29", sales: "2000 Sales", rating: 5, ratingCount: "123", image: "/assets/img/product/product_2_4.png" },
              ]}
              itemSchema={[
                { key: "title", label: "Title", type: "text" },
                { key: "category", label: "Category", type: "text" },
                { key: "price", label: "Price", type: "text" },
                { key: "sales", label: "Sales", type: "text" },
                { key: "ratingCount", label: "Rating Count", type: "text" },
                { key: "image", label: "Image", type: "image" },
                { key: "url", label: "URL", type: "text" },
              ]}
              onChange={(items) => handleChange({ ...content, products: items })}
              addItemText="Add Product"
            />
          </div>
        </>
      }
    />
  );
}
